import React, { useEffect, useState } from 'react';
import { Button, Card, Col, Form, Input, InputNumber, List, message, Row, Spin } from 'antd';
import { DownOutlined, UpOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom';
import formService from '../../../services/formService';

const text = {
  categoryManagementTitle: '\u8bfe\u7a0b\u7c7b\u522b\u7ba1\u7406',
  categoryTitle: '\u521b\u5efa\u8bfe\u7a0b\u7c7b\u522b',
  categoryDetailTitle: '\u8bfe\u7a0b\u7c7b\u522b\u4fe1\u606f',
  managementTitle: '\u8bfe\u7a0b\u540d\u79f0\u7ba1\u7406',
  nameManagementTitle: '\u8bfe\u7a0b\u540d\u79f0\u7ba1\u7406',
  title: '\u521b\u5efa\u8bfe\u7a0b',
  nameTitle: '\u521b\u5efa\u8bfe\u7a0b\u540d\u79f0',
  detailTitle: '\u8bfe\u7a0b\u4fe1\u606f',
  name: '\u8bfe\u7a0b\u540d\u79f0',
  lessonCount: '\u4e0a\u8bfe\u6b21\u6570',
  duration: '\u8bfe\u7a0b\u65f6\u957f\uff08\u6708\uff09',
  validity: '\u8bfe\u7a0b\u6709\u6548\u671f\uff08\u6708\uff09',
  weight: '\u8bfe\u7a0b\u987a\u5e8f\u503c',
  order: '\u8bfe\u7a0b\u987a\u5e8f\u503c',
  courseValue: '\u8bfe\u7a0b\u6570\u503c',
  create: '\u521b\u5efa\u8bfe\u7a0b',
  createCategory: '\u521b\u5efa\u8bfe\u7a0b\u7c7b\u522b',
  createName: '\u521b\u5efa\u8bfe\u7a0b\u540d\u79f0',
  createType: '\u521b\u5efa\u4e0a\u8bfe\u7c7b\u578b',
  typeName: '\u4e0a\u8bfe\u7c7b\u578b\u540d\u5b57',
  submit: '\u521b\u5efa',
  reset: '\u91cd\u7f6e',
  back: '\u8fd4\u56de\u8bfe\u7a0b\u7ba1\u7406',
  backCategory: '\u8fd4\u56de\u8bfe\u7a0b\u7c7b\u522b\u7ba1\u7406',
  backName: '\u8fd4\u56de\u8bfe\u7a0b\u540d\u79f0\u7ba1\u7406',
  backType: '\u8fd4\u56de\u4e0a\u8bfe\u7c7b\u578b\u7ba1\u7406',
  success: '\u8bfe\u7a0b\u5df2\u521b\u5efa',
  nameSuccess: '\u8bfe\u7a0b\u540d\u79f0\u5df2\u521b\u5efa',
  typeSuccess: '\u4e0a\u8bfe\u7c7b\u578b\u5df2\u521b\u5efa',
  failed: '\u521b\u5efa\u5931\u8d25',
  needRestart: '\u8bf7\u91cd\u542f\u540e\u7aef\u540e\u518d\u521b\u5efa',
  loadFailed: '\u8bfb\u53d6\u8bfe\u7a0b\u5931\u8d25',
  empty: '\u6682\u65e0\u8bfe\u7a0b',
  required: '\u8bf7\u586b\u5199',
  activeCourses: '\u4f7f\u7528\u4e2d\u7684\u8bfe\u7a0b',
  inactiveCourses: '\u4e4b\u524d\u7684\u8bfe\u7a0b',
  activeCourseCategories: '\u4f7f\u7528\u4e2d\u7684\u8bfe\u7a0b\u7c7b\u522b',
  inactiveCourseCategories: '\u4e4b\u524d\u7684\u8bfe\u7a0b\u7c7b\u522b',
  activeCourseNames: '\u4f7f\u7528\u4e2d\u7684\u8bfe\u7a0b\u540d\u79f0',
  inactiveCourseNames: '\u4e4b\u524d\u7684\u8bfe\u7a0b\u540d\u79f0',
  deleteName: '\u5220\u9664',
  active: '\u4f7f\u7528\u4e2d',
  inactive: '\u4e0d\u4f7f\u7528',
  statusFailed: '\u72b6\u6001\u4fdd\u5b58\u5931\u8d25',
  deleteFailed: '\u5220\u9664\u5931\u8d25',
  categorySuccess: '\u8bfe\u7a0b\u7c7b\u522b\u5df2\u521b\u5efa',
  typeManagementTitle: '\u4e0a\u8bfe\u7c7b\u578b\u7ba1\u7406',
  activeTypes: '\u4f7f\u7528\u4e2d\u7684\u4e0a\u8bfe\u7c7b\u578b',
  inactiveTypes: '\u4e4b\u524d\u7684\u4e0a\u8bfe\u7c7b\u578b',
  loadTypesFailed: '\u8bfb\u53d6\u4e0a\u8bfe\u7c7b\u578b\u5931\u8d25',
  emptyTypes: '\u6682\u65e0\u4e0a\u8bfe\u7c7b\u578b',
  edit: '\u66f4\u6539',
  save: '\u4fdd\u5b58',
  cancel: '\u53d6\u6d88',
  updateSuccess: '\u4fdd\u5b58\u6210\u529f',
  updateFailed: '\u4fdd\u5b58\u5931\u8d25',
};

const itemStyle = { width: '100%' };
const orderButtonStyle = { width: 24, padding: 0, marginRight: 4 };
const orderControlsStyle = { display: 'inline-flex', marginRight: 8 };

const sortCourses = (courses) => {
  return courses.sort((a, b) => {
    const aWeight = typeof a.weight === 'number' ? a.weight : Number(a.code);
    const bWeight = typeof b.weight === 'number' ? b.weight : Number(b.code);
    if (aWeight !== bWeight) return aWeight - bWeight;
    return String(a.createdAt || a._id || '').localeCompare(
      String(b.createdAt || b._id || '')
    );
  });
};

const sortCourseTypes = (courseTypes) => {
  return courseTypes.sort((a, b) => Number(a.weight || 0) - Number(b.weight || 0));
};

const sortCourseNames = (courseNames) => {
  return courseNames.sort((a, b) => {
    const aWeight =
      a.weight !== undefined && a.weight !== null ? Number(a.weight) : 0;
    const bWeight =
      b.weight !== undefined && b.weight !== null ? Number(b.weight) : 0;
    if (aWeight !== bWeight) return aWeight - bWeight;
    return String(a.createdAt || a._id || '').localeCompare(
      String(b.createdAt || b._id || '')
    );
  });
};

const sortCourseCategories = (courseCategories) => {
  return courseCategories.sort((a, b) => {
    const aOrder =
      a.weight !== undefined && a.weight !== null
        ? Number(a.weight)
        : Number.MAX_SAFE_INTEGER;
    const bOrder =
      b.weight !== undefined && b.weight !== null
        ? Number(b.weight)
        : Number.MAX_SAFE_INTEGER;
    if (aOrder !== bOrder) return aOrder - bOrder;
    return String(a.createdAt || a._id || '').localeCompare(
      String(b.createdAt || b._id || '')
    );
  });
};

const getReorderedItems = (items, index, direction, orderField = 'weight') => {
  const targetIndex = index + direction;
  if (targetIndex < 0 || targetIndex >= items.length) return null;
  const nextItems = [...items];
  const [movedItem] = nextItems.splice(index, 1);
  nextItems.splice(targetIndex, 0, movedItem);
  return nextItems.map((item, itemIndex) => ({
    ...item,
    [orderField]: (itemIndex + 1) * 10,
  }));
};

const CourseCategoryList = () => {
  const [loading, setLoading] = useState(true);
  const [savingId, setSavingId] = useState('');
  const [courseCategories, setCourseCategories] = useState([]);

  useEffect(() => {
    formService
      .queryCourseCategory()
      .then((res) => setCourseCategories(sortCourseCategories(res.data || [])))
      .catch(() => message.error(text.loadFailed))
      .finally(() => setLoading(false));
  }, []);

  const updateCourseCategory = async (courseCategory, data) => {
    setSavingId(courseCategory._id);
    try {
      const res = await formService.updateCourseCategory(courseCategory._id, data);
      setCourseCategories((prev) =>
        sortCourseCategories(
          prev.map((item) =>
            item._id === courseCategory._id ? { ...item, ...res.data } : item
          )
        )
      );
    } catch (error) {
      const errorMessage =
        error && error.response && error.response.data
          ? error.response.data.message
          : text.updateFailed;
      message.error(errorMessage || text.updateFailed);
    } finally {
      setSavingId('');
    }
  };

  const activeCourseCategories = courseCategories.filter(
    (courseCategory) => courseCategory.isActive !== false
  );
  const inactiveCourseCategories = courseCategories.filter(
    (courseCategory) => courseCategory.isActive === false
  );

  const moveCourseCategory = async (courseCategory, index, direction) => {
    const reorderedActiveCourseCategories = getReorderedItems(
      activeCourseCategories,
      index,
      direction
    );
    if (!reorderedActiveCourseCategories) return;
      setSavingId(courseCategory._id);
    try {
      for (const item of reorderedActiveCourseCategories) {
        await formService.updateCourseCategory(item._id, { weight: item.weight });
      }
      setCourseCategories((prev) =>
        sortCourseCategories(
          prev.map((item) =>
            reorderedActiveCourseCategories.find(
              (activeItem) => activeItem._id === item._id
            ) || item
          )
        )
      );
    } catch (error) {
      message.error(text.statusFailed);
    } finally {
      setSavingId('');
    }
  };

  const renderCourseCategoryItem = (
    courseCategory,
    index,
    total,
    showOrderControls = false
  ) => (
    <List.Item
      actions={[
        courseCategory.isActive === false ? (
          <Button
            size='small'
            loading={savingId === courseCategory._id}
            onClick={() => updateCourseCategory(courseCategory, { isActive: true })}
          >
            {text.inactive}
          </Button>
        ) : (
          <Button
            size='small'
            type='primary'
            loading={savingId === courseCategory._id}
            onClick={() => updateCourseCategory(courseCategory, { isActive: false })}
          >
            {text.active}
          </Button>
        ),
      ]}
    >
      {showOrderControls && (
        <span style={orderControlsStyle}>
          <Button
            size='small'
            icon={<UpOutlined />}
            style={orderButtonStyle}
            disabled={index === 0 || savingId === courseCategory._id}
            onClick={() => moveCourseCategory(courseCategory, index, -1)}
          />
          <Button
            size='small'
            icon={<DownOutlined />}
            style={orderButtonStyle}
            disabled={index === total - 1 || savingId === courseCategory._id}
            onClick={() => moveCourseCategory(courseCategory, index, 1)}
          />
        </span>
      )}
      <Link
        to={`/course-create/category-${courseCategory._id}`}
        style={{
          color: courseCategory.isActive === false ? '#999' : '#009688',
          textDecoration:
            courseCategory.isActive === false ? 'line-through' : 'none',
        }}
      >
        {courseCategory.name}
      </Link>
    </List.Item>
  );

  return (
    <Card
      title={text.categoryManagementTitle}
      extra={
        <Link to='/course-create/category-new'>
          <Button type='primary'>{text.createCategory}</Button>
        </Link>
      }
    >
      <Spin spinning={loading}>
        <div style={{ fontWeight: 500, marginBottom: 8 }}>
          {text.activeCourseCategories}
        </div>
        <List
          dataSource={activeCourseCategories}
          locale={{ emptyText: text.empty }}
          renderItem={(courseCategory, index) =>
            renderCourseCategoryItem(
              courseCategory,
              index,
              activeCourseCategories.length,
              true
            )
          }
        />
        <div style={{ fontWeight: 500, margin: '24px 0 8px' }}>
          {text.inactiveCourseCategories}
        </div>
        <List
          dataSource={inactiveCourseCategories}
          locale={{ emptyText: text.empty }}
          renderItem={(courseCategory, index) =>
            renderCourseCategoryItem(
              courseCategory,
              index,
              inactiveCourseCategories.length
            )
          }
        />
      </Spin>
    </Card>
  );
};

const CourseList = ({ title = text.managementTitle }) => {
  const [loading, setLoading] = useState(true);
  const [savingId, setSavingId] = useState('');
  const [courses, setCourses] = useState([]);

  useEffect(() => {
    formService
      .queryCourse(true)
      .then((res) => setCourses(sortCourses(res.data || [])))
      .catch(() => message.error(text.loadFailed))
      .finally(() => setLoading(false));
  }, []);

  const updateCourseStatus = async (course, isActive) => {
    setSavingId(course._id);
    try {
      await formService.updateCourse(course._id, { isActive });
      localStorage.removeItem('COURSE_LIST');
      setCourses((prev) =>
        sortCourses(
          prev.map((item) =>
            item._id === course._id ? { ...item, isActive } : item
          )
        )
      );
    } catch (error) {
      message.error(text.statusFailed);
    } finally {
      setSavingId('');
    }
  };

  const activeCourses = courses.filter((course) => course.isActive !== false);
  const inactiveCourses = courses.filter((course) => course.isActive === false);

  const moveCourse = async (course, index, direction) => {
    const reorderedActiveCourses = getReorderedItems(activeCourses, index, direction);
    if (!reorderedActiveCourses) return;
    setSavingId(course._id);
    try {
      await Promise.all(
        reorderedActiveCourses.map((item) =>
          formService.updateCourse(item._id, { weight: item.weight })
        )
      );
      localStorage.removeItem('COURSE_LIST');
      setCourses((prev) =>
        sortCourses(
          prev.map((item) =>
            reorderedActiveCourses.find((activeItem) => activeItem._id === item._id) ||
            item
          )
        )
      );
    } catch (error) {
      message.error(text.statusFailed);
    } finally {
      setSavingId('');
    }
  };

  const renderCourseItem = (course, index, total, showOrderControls = false) => (
    <List.Item
      actions={[
        course.isActive === false ? (
          <Button
            size='small'
            loading={savingId === course._id}
            onClick={() => updateCourseStatus(course, true)}
          >
            {text.inactive}
          </Button>
        ) : (
          <Button
            size='small'
            type='primary'
            loading={savingId === course._id}
            onClick={() => updateCourseStatus(course, false)}
          >
            {text.active}
          </Button>
        ),
      ]}
    >
      {showOrderControls && (
        <span style={orderControlsStyle}>
          <Button
            size='small'
            icon={<UpOutlined />}
            style={orderButtonStyle}
            disabled={index === 0 || savingId === course._id}
            onClick={() => moveCourse(course, index, -1)}
          />
          <Button
            size='small'
            icon={<DownOutlined />}
            style={orderButtonStyle}
            disabled={index === total - 1 || savingId === course._id}
            onClick={() => moveCourse(course, index, 1)}
          />
        </span>
      )}
      <Link
        to={`/course-create/${course._id}`}
        style={{
          color: course.isActive === false ? '#999' : undefined,
          textDecoration: course.isActive === false ? 'line-through' : 'none',
        }}
      >
        {course.name}
      </Link>
    </List.Item>
  );

  return (
    <Card
      title={title}
      extra={
        <Link to='/course-create/new'>
          <Button type='primary'>{text.createName}</Button>
        </Link>
      }
    >
      <Spin spinning={loading}>
        <div style={{ fontWeight: 500, marginBottom: 8 }}>{text.activeCourses}</div>
        <List
          dataSource={activeCourses}
          locale={{ emptyText: text.empty }}
          renderItem={(course, index) =>
            renderCourseItem(course, index, activeCourses.length, true)
          }
        />
        <div style={{ fontWeight: 500, margin: '24px 0 8px' }}>
          {text.inactiveCourses}
        </div>
        <List
          dataSource={inactiveCourses}
          locale={{ emptyText: text.empty }}
          renderItem={(course, index) =>
            renderCourseItem(course, index, inactiveCourses.length)
          }
        />
      </Spin>
    </Card>
  );
};

const CourseNameList = () => {
  const [loading, setLoading] = useState(true);
  const [savingId, setSavingId] = useState('');
  const [courseNames, setCourseNames] = useState([]);
  const [creating, setCreating] = useState(false);
  const [newName, setNewName] = useState('');
  const [creatingName, setCreatingName] = useState(false);
  const [editingId, setEditingId] = useState('');
  const [editingName, setEditingName] = useState('');

  useEffect(() => {
    formService
      .queryCourseName()
      .then((res) => setCourseNames(sortCourseNames(res.data || [])))
      .catch(() => message.error(text.loadFailed))
      .finally(() => setLoading(false));
  }, []);

  const createCourseName = async () => {
    const name = newName.trim();
    if (!name) {
      message.error(`${text.required}${text.name}`);
      return;
    }
    setCreatingName(true);
    try {
      const res = await formService.createCourseName({
        name,
        isActive: true,
        weight: (courseNames.length + 1) * 10,
      });
      setCourseNames((prev) => sortCourseNames([...prev, res.data]));
      setNewName('');
      setCreating(false);
      message.success(text.nameSuccess);
    } catch (error) {
      const errorMessage =
        error && error.response && error.response.data
          ? error.response.data.message
          : text.failed;
      message.error(errorMessage || text.failed);
    } finally {
      setCreatingName(false);
    }
  };

  const updateCourseName = async (courseName, data) => {
    setSavingId(courseName._id);
    try {
      const res = await formService.updateCourseName(courseName._id, data);
      setCourseNames((prev) =>
        sortCourseNames(
          prev.map((item) =>
            item._id === courseName._id ? { ...item, ...res.data } : item
          )
        )
      );
      setEditingId('');
      setEditingName('');
    } catch (error) {
      const errorMessage =
        error && error.response && error.response.data
          ? error.response.data.message
          : text.updateFailed;
      message.error(errorMessage || text.updateFailed);
    } finally {
      setSavingId('');
    }
  };

  const saveCourseName = (courseName) => {
    const name = editingName.trim();
    if (!name) {
      message.error(`${text.required}${text.name}`);
      return;
    }
    updateCourseName(courseName, { name });
  };

  const activeCourseNames = courseNames.filter(
    (courseName) => courseName.isActive !== false
  );
  const inactiveCourseNames = courseNames.filter(
    (courseName) => courseName.isActive === false
  );

  const moveCourseName = async (courseName, index, direction) => {
    const reorderedActiveCourseNames = getReorderedItems(
      activeCourseNames,
      index,
      direction
    );
    if (!reorderedActiveCourseNames) return;
    setSavingId(courseName._id);
    try {
      for (const item of reorderedActiveCourseNames) {
        await formService.updateCourseName(item._id, { weight: item.weight });
      }
      setCourseNames((prev) =>
        sortCourseNames(
          prev.map((item) =>
            reorderedActiveCourseNames.find(
              (activeItem) => activeItem._id === item._id
            ) || item
          )
        )
      );
    } catch (error) {
      message.error(text.statusFailed);
    } finally {
      setSavingId('');
    }
  };

  const renderCourseNameItem = (
    courseName,
    index,
    total,
    showOrderControls = false
  ) => (
    <List.Item
      actions={[
        courseName.isActive === false ? (
          <Button
            size='small'
            loading={savingId === courseName._id}
            onClick={() => updateCourseName(courseName, { isActive: true })}
          >
            {text.inactive}
          </Button>
        ) : (
          <Button
            size='small'
            type='primary'
            loading={savingId === courseName._id}
            onClick={() => updateCourseName(courseName, { isActive: false })}
          >
            {text.active}
          </Button>
        ),
      ]}
    >
      {showOrderControls && (
        <span style={orderControlsStyle}>
          <Button
            size='small'
            icon={<UpOutlined />}
            style={orderButtonStyle}
            disabled={index === 0 || savingId === courseName._id}
            onClick={() => moveCourseName(courseName, index, -1)}
          />
          <Button
            size='small'
            icon={<DownOutlined />}
            style={orderButtonStyle}
            disabled={index === total - 1 || savingId === courseName._id}
            onClick={() => moveCourseName(courseName, index, 1)}
          />
        </span>
      )}
      {editingId === courseName._id ? (
        <span style={{ display: 'flex', width: '100%' }}>
          <Input
            value={editingName}
            onChange={(e) => setEditingName(e.target.value)}
            onPressEnter={() => saveCourseName(courseName)}
          />
          <Button
            size='small'
            type='primary'
            loading={savingId === courseName._id}
            style={{ marginLeft: 8 }}
            onClick={() => saveCourseName(courseName)}
          >
            {text.save}
          </Button>
          <Button
            size='small'
            style={{ marginLeft: 8 }}
            onClick={() => {
              setEditingId('');
              setEditingName('');
            }}
          >
            {text.cancel}
          </Button>
        </span>
      ) : (
        <span
          style={{
            cursor: 'pointer',
            color: courseName.isActive === false ? '#999' : '#009688',
            textDecoration: courseName.isActive === false ? 'line-through' : 'none',
          }}
          onClick={() => {
            setEditingId(courseName._id);
            setEditingName(courseName.name);
          }}
        >
          {courseName.name}
        </span>
      )}
    </List.Item>
  );

  return (
    <Card
      title={text.nameManagementTitle}
      extra={
        <Button type='primary' onClick={() => setCreating(true)}>
          {text.createName}
        </Button>
      }
    >
      <Spin spinning={loading}>
        {creating && (
          <div style={{ display: 'flex', marginBottom: 16 }}>
            <Input
              value={newName}
              placeholder={text.name}
              onChange={(e) => setNewName(e.target.value)}
              onPressEnter={createCourseName}
            />
            <Button
              type='primary'
              loading={creatingName}
              style={{ marginLeft: 8 }}
              onClick={createCourseName}
            >
              {text.submit}
            </Button>
            <Button
              style={{ marginLeft: 8 }}
              onClick={() => {
                setCreating(false);
                setNewName('');
              }}
            >
              {text.reset}
            </Button>
          </div>
        )}
        <div style={{ fontWeight: 500, marginBottom: 8 }}>
          {text.activeCourseNames}
        </div>
        <List
          dataSource={activeCourseNames}
          locale={{ emptyText: text.empty }}
          renderItem={(courseName, index) =>
            renderCourseNameItem(courseName, index, activeCourseNames.length, true)
          }
        />
        <div style={{ fontWeight: 500, margin: '24px 0 8px' }}>
          {text.inactiveCourseNames}
        </div>
        <List
          dataSource={inactiveCourseNames}
          locale={{ emptyText: text.empty }}
          renderItem={(courseName, index) =>
            renderCourseNameItem(courseName, index, inactiveCourseNames.length)
          }
        />
      </Spin>
    </Card>
  );
};

const CourseTypeList = () => {
  const [loading, setLoading] = useState(true);
  const [savingId, setSavingId] = useState('');
  const [courseTypes, setCourseTypes] = useState([]);

  useEffect(() => {
    formService
      .queryCourseType(true)
      .then((res) => setCourseTypes(sortCourseTypes(res.data || [])))
      .catch(() => message.error(text.loadTypesFailed))
      .finally(() => setLoading(false));
  }, []);

  const updateCourseTypeStatus = async (courseType, isActive) => {
    setSavingId(courseType._id);
    try {
      await formService.updateCourseType(courseType._id, { isActive });
      localStorage.removeItem('COURSE_TYPE_LIST');
      setCourseTypes((prev) =>
        sortCourseTypes(
          prev.map((item) =>
            item._id === courseType._id ? { ...item, isActive } : item
          )
        )
      );
    } catch (error) {
      message.error(text.statusFailed);
    } finally {
      setSavingId('');
    }
  };

  const activeTypes = courseTypes.filter((courseType) => courseType.isActive !== false);
  const inactiveTypes = courseTypes.filter((courseType) => courseType.isActive === false);

  const moveCourseType = async (courseType, index, direction) => {
    const reorderedActiveTypes = getReorderedItems(activeTypes, index, direction);
    if (!reorderedActiveTypes) return;
    setSavingId(courseType._id);
    try {
      await Promise.all(
        reorderedActiveTypes.map((item) =>
          formService.updateCourseType(item._id, { weight: item.weight })
        )
      );
      localStorage.removeItem('COURSE_TYPE_LIST');
      setCourseTypes((prev) =>
        sortCourseTypes(
          prev.map((item) =>
            reorderedActiveTypes.find((activeItem) => activeItem._id === item._id) ||
            item
          )
        )
      );
    } catch (error) {
      message.error(text.statusFailed);
    } finally {
      setSavingId('');
    }
  };

  const renderCourseTypeItem = (
    courseType,
    index,
    total,
    showOrderControls = false
  ) => (
    <List.Item
      actions={[
        courseType.isActive === false ? (
          <Button
            size='small'
            loading={savingId === courseType._id}
            onClick={() => updateCourseTypeStatus(courseType, true)}
          >
            {text.inactive}
          </Button>
        ) : (
          <Button
            size='small'
            type='primary'
            loading={savingId === courseType._id}
            onClick={() => updateCourseTypeStatus(courseType, false)}
          >
            {text.active}
          </Button>
        ),
      ]}
    >
      {showOrderControls && (
        <span style={orderControlsStyle}>
          <Button
            size='small'
            icon={<UpOutlined />}
            style={orderButtonStyle}
            disabled={index === 0 || savingId === courseType._id}
            onClick={() => moveCourseType(courseType, index, -1)}
          />
          <Button
            size='small'
            icon={<DownOutlined />}
            style={orderButtonStyle}
            disabled={index === total - 1 || savingId === courseType._id}
            onClick={() => moveCourseType(courseType, index, 1)}
          />
        </span>
      )}
      <span
        style={{
          color: courseType.isActive === false ? '#999' : undefined,
          textDecoration: courseType.isActive === false ? 'line-through' : 'none',
        }}
      >
        {courseType.name}
      </span>
    </List.Item>
  );

  return (
    <Card
      title={text.typeManagementTitle}
      extra={
        <Link to='/course-create/type-new'>
          <Button type='primary'>{text.createType}</Button>
        </Link>
      }
    >
      <Spin spinning={loading}>
        <div style={{ fontWeight: 500, marginBottom: 8 }}>{text.activeTypes}</div>
        <List
          dataSource={activeTypes}
          locale={{ emptyText: text.emptyTypes }}
          renderItem={(courseType, index) =>
            renderCourseTypeItem(courseType, index, activeTypes.length, true)
          }
        />
        <div style={{ fontWeight: 500, margin: '24px 0 8px' }}>
          {text.inactiveTypes}
        </div>
        <List
          dataSource={inactiveTypes}
          locale={{ emptyText: text.emptyTypes }}
          renderItem={(courseType, index) =>
            renderCourseTypeItem(courseType, index, inactiveTypes.length)
          }
        />
      </Spin>
    </Card>
  );
};

const CourseTypeCreateForm = ({ history }) => {
  const [form] = Form.useForm();
  const [saving, setSaving] = useState(false);

  const handleSubmit = async (values) => {
    setSaving(true);
    try {
      await formService.createCourseType({ name: values.name });
      localStorage.removeItem('COURSE_TYPE_LIST');
      message.success(text.typeSuccess);
      form.resetFields();
      history.push('/course-create');
    } catch (error) {
      const status = error && error.response ? error.response.status : null;
      const errorMessage =
        status === 404 || status === 405
          ? text.needRestart
          : error && error.response && error.response.data
            ? error.response.data.message
            : text.failed;
      message.error(errorMessage || text.failed);
    } finally {
      setSaving(false);
    }
  };

  return (
    <div style={{ display: 'flex', justifyContent: 'center', paddingTop: 40 }}>
      <Card title={text.createType} style={{ width: 460 }}>
        <div style={{ marginBottom: 16 }}>
          <Link to='/course-create'>{text.backType}</Link>
        </div>
        <Form layout='vertical' form={form} onFinish={handleSubmit}>
          <Form.Item
            label={text.typeName}
            name='name'
            rules={[{ required: true, message: `${text.required}${text.typeName}` }]}
          >
            <Input />
          </Form.Item>
          <Form.Item>
            <Button type='primary' htmlType='submit' loading={saving}>
              {text.submit}
            </Button>
            <Button
              htmlType='button'
              style={{ marginLeft: 12 }}
              onClick={() => form.resetFields()}
            >
              {text.reset}
            </Button>
          </Form.Item>
        </Form>
      </Card>
    </div>
  );
};

const CourseCategoryCreateForm = ({ history }) => {
  const [form] = Form.useForm();
  const [saving, setSaving] = useState(false);

  const handleSubmit = async (values) => {
    const payload = {
      name: values.name,
      lessonCount:
        values.lessonCount !== undefined && values.lessonCount !== null
          ? Number(values.lessonCount)
          : undefined,
      duration:
        values.duration !== undefined && values.duration !== null
          ? Number(values.duration)
          : undefined,
      validity:
        values.validity !== undefined && values.validity !== null
          ? Number(values.validity)
          : undefined,
      courseValue:
        values.courseValue !== undefined && values.courseValue !== null
          ? Number(values.courseValue)
          : undefined,
      weight:
        values.weight !== undefined && values.weight !== null
          ? Number(values.weight)
          : undefined,
      isActive: true,
    };

    setSaving(true);
    try {
      await formService.createCourseCategory(payload);
      message.success(text.categorySuccess);
      form.resetFields();
      history.push('/course-create');
    } catch (error) {
      const errorMessage =
        error && error.response && error.response.data
          ? error.response.data.message
          : text.failed;
      message.error(errorMessage || text.failed);
    } finally {
      setSaving(false);
    }
  };

  return (
    <div style={{ display: 'flex', justifyContent: 'center', paddingTop: 40 }}>
      <Card title={text.categoryTitle} style={{ width: 460 }}>
        <div style={{ marginBottom: 16 }}>
          <Link to='/course-create'>{text.backCategory}</Link>
        </div>
        <Form layout='vertical' form={form} onFinish={handleSubmit}>
          <Form.Item
            label='类别名称'
            name='name'
            rules={[{ required: true, message: `${text.required}类别名称` }]}
          >
            <Input />
          </Form.Item>
          <Form.Item label={text.lessonCount} name='lessonCount'>
            <InputNumber min={0} precision={0} style={itemStyle} />
          </Form.Item>
          <Form.Item label={text.duration} name='duration'>
            <InputNumber
              min={0}
              step={0.5}
              precision={1}
              style={itemStyle}
              addonAfter='月'
            />
          </Form.Item>
          <Form.Item label={text.validity} name='validity'>
            <InputNumber
              min={0}
              step={0.5}
              precision={1}
              style={itemStyle}
              addonAfter='月'
            />
          </Form.Item>
          <Form.Item label={text.courseValue} name='courseValue'>
            <InputNumber min={0} step={0.5} precision={1} style={itemStyle} />
          </Form.Item>
          <Form.Item label={text.order} name='weight'>
            <InputNumber min={0} step={1} precision={0} style={itemStyle} />
          </Form.Item>
          <Form.Item>
            <Button type='primary' htmlType='submit' loading={saving}>
              {text.submit}
            </Button>
            <Button
              htmlType='button'
              style={{ marginLeft: 12 }}
              onClick={() => form.resetFields()}
            >
              {text.reset}
            </Button>
          </Form.Item>
        </Form>
      </Card>
    </div>
  );
};

const CourseCategoryDetail = ({ categoryId, history }) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [editing, setEditing] = useState(false);
  const [courseCategory, setCourseCategory] = useState({});

  const setCategoryForm = (target) => {
    form.setFieldsValue({
      name: target.name,
      lessonCount: target.lessonCount,
      duration: target.duration,
      validity: target.validity,
      courseValue:
        target.courseValue !== undefined && target.courseValue !== null
          ? target.courseValue
          : 2,
      weight: target.weight,
    });
  };

  useEffect(() => {
    formService
      .queryCourseCategory()
      .then((res) => {
        const target =
          (res.data || []).find((item) => item._id === categoryId) || {};
        setCourseCategory(target);
        setCategoryForm(target);
      })
      .catch(() => message.error(text.loadFailed))
      .finally(() => setLoading(false));
  }, [categoryId]);

  const handleCancel = () => {
    setCategoryForm(courseCategory);
    setEditing(false);
  };

  const handleSave = async (values) => {
    const payload = {
      name: values.name,
      lessonCount:
        values.lessonCount !== undefined && values.lessonCount !== null
          ? Number(values.lessonCount)
          : undefined,
      duration:
        values.duration !== undefined && values.duration !== null
          ? Number(values.duration)
          : undefined,
      validity:
        values.validity !== undefined && values.validity !== null
          ? Number(values.validity)
          : undefined,
      courseValue:
        values.courseValue !== undefined && values.courseValue !== null
          ? Number(values.courseValue)
          : undefined,
      weight:
        values.weight !== undefined && values.weight !== null
          ? Number(values.weight)
          : undefined,
    };
    setSaving(true);
    try {
      const res = await formService.updateCourseCategory(categoryId, payload);
      const nextCategory = { ...courseCategory, ...(res.data || {}), ...payload };
      setCourseCategory(nextCategory);
      setCategoryForm(nextCategory);
      setEditing(false);
      message.success(text.updateSuccess);
      history.push('/course-create');
    } catch (error) {
      message.error(text.updateFailed);
    } finally {
      setSaving(false);
    }
  };

  return (
    <div style={{ display: 'flex', justifyContent: 'center', paddingTop: 40 }}>
      <Card
        title={text.categoryDetailTitle}
        style={{ width: 460 }}
        extra={<Link to='/course-create'>{text.backCategory}</Link>}
      >
        <Spin spinning={loading}>
          <Form layout='vertical' form={form} onFinish={handleSave}>
            <Form.Item
              label='类别名称'
              name='name'
              rules={[{ required: true, message: `${text.required}类别名称` }]}
            >
              <Input disabled={!editing} />
            </Form.Item>
            <Form.Item label={text.lessonCount} name='lessonCount'>
              <InputNumber min={0} precision={0} style={itemStyle} disabled={!editing} />
            </Form.Item>
            <Form.Item label={text.duration} name='duration'>
              <InputNumber
                min={0}
                step={0.5}
                precision={1}
                style={itemStyle}
                addonAfter='月'
                disabled={!editing}
              />
            </Form.Item>
            <Form.Item label={text.validity} name='validity'>
              <InputNumber
                min={0}
                step={0.5}
                precision={1}
                style={itemStyle}
                addonAfter='月'
                disabled={!editing}
              />
            </Form.Item>
            <Form.Item label={text.courseValue} name='courseValue'>
              <InputNumber
                min={0}
                step={0.5}
                precision={1}
                style={itemStyle}
                disabled={!editing}
              />
            </Form.Item>
            <Form.Item label={text.order} name='weight'>
              <InputNumber
                min={0}
                step={1}
                precision={0}
                style={itemStyle}
                disabled={!editing}
              />
            </Form.Item>
            {editing && (
              <Form.Item>
                <Button type='primary' htmlType='submit' loading={saving}>
                  {text.save}
                </Button>
                <Button htmlType='button' style={{ marginLeft: 12 }} onClick={handleCancel}>
                  {text.cancel}
                </Button>
              </Form.Item>
            )}
          </Form>
          {!editing && (
            <Button type='primary' htmlType='button' onClick={() => setEditing(true)}>
              {text.edit}
            </Button>
          )}
        </Spin>
      </Card>
    </div>
  );
};

const CourseNameCreateForm = ({ history }) => {
  const [form] = Form.useForm();
  const [saving, setSaving] = useState(false);

  const handleSubmit = async (values) => {
    setSaving(true);
    try {
      await formService.createCourseName({ name: values.name });
      message.success(text.nameSuccess);
      form.resetFields();
      history.push('/course-create');
    } catch (error) {
      const errorMessage =
        error && error.response && error.response.data
          ? error.response.data.message
          : text.failed;
      message.error(errorMessage || text.failed);
    } finally {
      setSaving(false);
    }
  };

  return (
    <div style={{ display: 'flex', justifyContent: 'center', paddingTop: 40 }}>
      <Card title={text.nameTitle} style={{ width: 460 }}>
        <div style={{ marginBottom: 16 }}>
          <Link to='/course-create'>{text.backName}</Link>
        </div>
        <Form layout='vertical' form={form} onFinish={handleSubmit}>
          <Form.Item
            label={text.name}
            name='name'
            rules={[{ required: true, message: `${text.required}${text.name}` }]}
          >
            <Input />
          </Form.Item>
          <Form.Item>
            <Button type='primary' htmlType='submit' loading={saving}>
              {text.submit}
            </Button>
            <Button
              htmlType='button'
              style={{ marginLeft: 12 }}
              onClick={() => form.resetFields()}
            >
              {text.reset}
            </Button>
          </Form.Item>
        </Form>
      </Card>
    </div>
  );
};

const CourseDetail = ({ courseId, history }) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [editing, setEditing] = useState(false);
  const [course, setCourse] = useState({});

  const setCourseForm = (target) => {
    form.setFieldsValue({
      name: target.name,
      lessonCount: target.lessonCount,
      duration: target.duration,
      validity: target.validity,
      weight: target.weight,
    });
  };

  useEffect(() => {
    formService
      .queryCourse(true)
      .then((res) => {
        const target = (res.data || []).find((item) => item._id === courseId) || {};
        setCourse(target);
        setCourseForm(target);
      })
      .catch(() => message.error(text.loadFailed))
      .finally(() => setLoading(false));
  }, [courseId]);

  const handleEdit = () => {
    setEditing(true);
  };

  const handleCancel = () => {
    setCourseForm(course);
    setEditing(false);
  };

  const handleSave = async (values) => {
    const payload = {
      name: values.name,
      lessonCount:
        values.lessonCount !== undefined && values.lessonCount !== null
          ? Number(values.lessonCount)
          : undefined,
      duration:
        values.duration !== undefined && values.duration !== null
          ? Number(values.duration)
          : undefined,
      validity:
        values.validity !== undefined && values.validity !== null
          ? Number(values.validity)
          : undefined,
      weight:
        values.weight !== undefined && values.weight !== null
          ? Number(values.weight)
          : undefined,
    };
    setSaving(true);
    try {
      const res = await formService.updateCourse(courseId, payload);
      const nextCourse = { ...course, ...(res.data || {}), ...payload };
      localStorage.removeItem('COURSE_LIST');
      setCourse(nextCourse);
      setCourseForm(nextCourse);
      setEditing(false);
      message.success(text.updateSuccess);
      history.push('/course-create');
    } catch (error) {
      message.error(text.updateFailed);
    } finally {
      setSaving(false);
    }
  };

  return (
    <div style={{ display: 'flex', justifyContent: 'center', paddingTop: 40 }}>
      <Card
        title={text.detailTitle}
        style={{ width: 460 }}
        extra={<Link to='/course-create'>{text.back}</Link>}
      >
        <Spin spinning={loading}>
          <Form layout='vertical' form={form} onFinish={handleSave}>
            <Form.Item
              label={text.name}
              name='name'
              rules={[{ required: true, message: `${text.required}${text.name}` }]}
            >
              <Input disabled={!editing} />
            </Form.Item>
            <Form.Item label={text.lessonCount} name='lessonCount'>
              <InputNumber min={0} precision={0} style={itemStyle} disabled={!editing} />
            </Form.Item>
            <Form.Item label={text.duration} name='duration'>
              <InputNumber
                min={0}
                step={0.5}
                precision={1}
                style={itemStyle}
                addonAfter='月'
                disabled={!editing}
              />
            </Form.Item>
            <Form.Item label={text.validity} name='validity'>
              <InputNumber
                min={0}
                step={0.5}
                precision={1}
                style={itemStyle}
                addonAfter='月'
                disabled={!editing}
              />
            </Form.Item>
            <Form.Item label={text.order} name='weight'>
              <InputNumber
                min={0}
                step={0.5}
                precision={1}
                style={itemStyle}
                disabled={!editing}
              />
            </Form.Item>
            {editing && (
              <Form.Item>
                <Button type='primary' htmlType='submit' loading={saving}>
                  {text.save}
                </Button>
                <Button htmlType='button' style={{ marginLeft: 12 }} onClick={handleCancel}>
                  {text.cancel}
                </Button>
              </Form.Item>
            )}
          </Form>
          {!editing && (
            <Button type='primary' htmlType='button' onClick={handleEdit}>
              {text.edit}
            </Button>
          )}
        </Spin>
      </Card>
    </div>
  );
};
const CourseCreateForm = ({ history }) => {
  const [form] = Form.useForm();
  const [saving, setSaving] = useState(false);

  const handleSubmit = async (values) => {
    const payload = {
      name: values.name,
      lessonCount:
        values.lessonCount !== undefined && values.lessonCount !== null
          ? Number(values.lessonCount)
          : undefined,
      duration:
        values.duration !== undefined && values.duration !== null
          ? Number(values.duration)
          : undefined,
      validity:
        values.validity !== undefined && values.validity !== null
          ? Number(values.validity)
          : undefined,
      weight:
        values.weight !== undefined && values.weight !== null
          ? Number(values.weight)
          : undefined,
      code: `${Date.now()}`,
      isActive: true,
    };

    setSaving(true);
    try {
      await formService.createCourse(payload);
      localStorage.removeItem('COURSE_LIST');
      message.success(text.success);
      form.resetFields();
      history.push('/course-create');
    } catch (error) {
      const errorMessage =
        error && error.response && error.response.data
          ? error.response.data.message
          : text.failed;
      message.error(errorMessage || text.failed);
    } finally {
      setSaving(false);
    }
  };

  return (
    <div style={{ display: 'flex', justifyContent: 'center', paddingTop: 40 }}>
      <Card title={text.nameTitle} style={{ width: 460 }}>
        <div style={{ marginBottom: 16 }}>
          <Link to='/course-create'>{text.back}</Link>
        </div>
        <Form layout='vertical' form={form} onFinish={handleSubmit}>
          <Form.Item
            label={text.name}
            name='name'
            rules={[{ required: true, message: `${text.required}${text.name}` }]}
          >
            <Input />
          </Form.Item>
          <Form.Item label={text.lessonCount} name='lessonCount'>
            <InputNumber min={0} precision={0} style={itemStyle} />
          </Form.Item>
          <Form.Item label={text.duration} name='duration'>
            <InputNumber
              min={0}
              step={0.5}
              precision={1}
              style={itemStyle}
              addonAfter='月'
            />
          </Form.Item>
          <Form.Item label={text.validity} name='validity'>
            <InputNumber
              min={0}
              step={0.5}
              precision={1}
              style={itemStyle}
              addonAfter='月'
            />
          </Form.Item>
          <Form.Item label={text.order} name='weight'>
            <InputNumber min={0} step={0.5} precision={1} style={itemStyle} />
          </Form.Item>
          <Form.Item>
            <Button type='primary' htmlType='submit' loading={saving}>
              {text.submit}
            </Button>
            <Button
              htmlType='button'
              style={{ marginLeft: 12 }}
              onClick={() => form.resetFields()}
            >
              {text.reset}
            </Button>
          </Form.Item>
        </Form>
      </Card>
    </div>
  );
};

const CourseCreate = ({ match, history }) => {
  const courseId = match.params.id;

  if (courseId === 'new') {
    return <CourseCreateForm history={history} />;
  }

  if (courseId === 'type-new') {
    return <CourseTypeCreateForm history={history} />;
  }

  if (courseId === 'category-new') {
    return <CourseCategoryCreateForm history={history} />;
  }

  if (courseId === 'name-new') {
    return <CourseNameCreateForm history={history} />;
  }

  if (courseId && courseId.indexOf('category-') === 0) {
    return (
      <CourseCategoryDetail
        categoryId={courseId.replace('category-', '')}
        history={history}
      />
    );
  }

  if (courseId) {
    return <CourseDetail courseId={courseId} history={history} />;
  }

  return (
    <div style={{ maxWidth: 1480, margin: '40px auto' }}>
      <Row gutter={24} align='top'>
        <Col xs={24} lg={8}>
          <CourseCategoryList />
        </Col>
        <Col xs={24} lg={8}>
          <CourseList />
        </Col>
        <Col xs={24} lg={8}>
          <CourseTypeList />
        </Col>
      </Row>
    </div>
  );
};

export default CourseCreate;

